import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-courses my-2"},[_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,_vm._l((_vm.filteredFields),function(field){return _c(VCol,{key:field.name,staticClass:"py-1",attrs:{"cols":"12","sm":"12","md":field.col}},[_c('DialogInput',{attrs:{"field":field,"data":_vm.entity,"detail":_vm.detail}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }